export default {
    "heatmap": {
        "name": "Heatmap",
        "nodata": "No data to display",
        "loading": "Loading",
        "maxX": "Max items on X axis",
        "maxY": "Max items on Y axis",
        "rescale": "Re-scale axes",
        "colors": "Color scheme",
        "blue": "Blue",
        "red": "Red",
        "green": "Green",
        "diverging": "Diverging",
        "spectral": "Spectral",
        "cool": "Cool",
        "defaults": "Defaults",
        "showing": "Showing {shown, number} of {total, number} tiles",
        "tooltip": "{count, plural, one {# item} other {# items}}"
    },
};
